import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { filterSportsEmitLast } from '@frontend/sports/host-app/sports-product/feature/utils';

import { ArcRestrictionService } from '../../arc/arc-restriction.service';
import { EarlyPayoutUtils } from '../../my-bets-base/early-payout/early-payout-utils';
import { MyBetsBetSlip } from '../../my-bets-base/models/my-bets-viewmodels';
import { EarlypayoutButtonState, MyBetsEarlypayoutButtonStateService } from './my-bets-earlypayout-button-state.service';

@Injectable()
export class EditMyBetButtonStateService {
    isUserOnPlayBreak: boolean;

    constructor(
        private myBetsEarlypayoutButtonStateService: MyBetsEarlypayoutButtonStateService,
        private earlyPayoutUtils: EarlyPayoutUtils,
        private arcRestrictionService: ArcRestrictionService,
    ) {
        this.arcRestrictionService.isUserOnPlayBreak$.pipe(filterSportsEmitLast(), takeUntilDestroyed()).subscribe((data) => {
            this.isUserOnPlayBreak = data;
        });
    }

    isEnabled(betslip: MyBetsBetSlip): boolean {
        return (
            !this.earlyPayoutUtils.isEditBetDisabled(betslip) &&
            this.myBetsEarlypayoutButtonStateService.buttonState(betslip) === EarlypayoutButtonState.Allowed &&
            !this.isUserOnPlayBreak
        );
    }
}
